import { RoleEnum } from "../../shared/models"

export interface IUser {
    division : Array<string>,
    company_code : Array<number>,
    plant_code : Array<number>,
    location : string,
    user_name : string,
    gid : string,
    user_email : string,
    netprice_start : any,
    netprice_end : any,
    currency : any,
    direct_indirect : any,
    commodity : any,
    role : RoleEnum | string,
    active: any,
    esn: any[],
    user_id: any,
    mobile_no?: any,
    domain?:any,
    department?:any,
    manager_gid?:any,
    id:any
}

export interface IUserResp {
    users : IUser[]
}

export interface IDivisionDetailsResp {
    division : string;
    id: number | string;
    threshold: string;
}

export interface IFPACTIVESTATUS{
    factory_procurement_approval: string;
    reporting_manager: string;
}

export interface IDivisionResp {
    division : Array<string>;
}

export interface ICompanyCodeResp {
    company_code : Array<string>;
}

// export type UserRoleType = Record<"plant_code" | "company_code" | "division" | "esn_code", Record<RoleEnum, boolean>>;
export type UserRoleType = Record<"plant_code" | "company_code" | "division" | "esn", any>;

export const USER_RULES : UserRoleType  = { // true for multi, false for single selection
    plant_code : {
        [RoleEnum.REQUESTER] : true,
        [RoleEnum.ADMIN] : true,
        [RoleEnum.BUYER] : true,
        [RoleEnum.PO_BUYER] : true,
        [RoleEnum.QES_APPROVER] : true,
        [RoleEnum.SUPPLIER] : true,
        [RoleEnum.REPORTING_MANAGER] : true,
        [RoleEnum.EHS_MANAGER]: true
    },
    company_code : {
        [RoleEnum.REQUESTER] : true,
        [RoleEnum.ADMIN] : true,
        [RoleEnum.BUYER] : true,
        [RoleEnum.PO_BUYER] : true,
        [RoleEnum.QES_APPROVER] : true,
        [RoleEnum.SUPPLIER] : true,
        [RoleEnum.REPORTING_MANAGER] : true,
        [RoleEnum.EHS_MANAGER]: true
    },
    division : {
        [RoleEnum.REQUESTER] : true,
        [RoleEnum.ADMIN] : true,
        [RoleEnum.BUYER] : true,
        [RoleEnum.PO_BUYER] : true,
        [RoleEnum.QES_APPROVER] : true,
        [RoleEnum.SUPPLIER] : true,
        [RoleEnum.REPORTING_MANAGER] : true,
        [RoleEnum.EHS_MANAGER]: true
    },
    esn : {
        [RoleEnum.REQUESTER] : true,
        [RoleEnum.ADMIN] : true,
        [RoleEnum.BUYER] : true,
        [RoleEnum.PO_BUYER] : true,
        [RoleEnum.QES_APPROVER] : true,
        [RoleEnum.SUPPLIER] : true,
        [RoleEnum.REPORTING_MANAGER] : true,
        [RoleEnum.EHS_MANAGER]: true
    }
} 

export interface IItracerRequest {
    username : string;
    role : string;
    domain : string;
}

export interface IITracerUser {
    OrgId: string
    department: string
    email_id: string
    gid: string
    gidMan1: string
    maIdent: string
    manager: string
    mobile: string
    name: string
    role: string
    surname: string
    manager_gid?:any
}